import { Popconfirm, Space, Table, Tag } from "antd";
import React, { useContext } from "react";
import { UserContext } from "../../../context";
import history from "../../../routes/history";

const { Column } = Table;
export default function MotoristasTable({
  motoristas,
  loading,
  handleTableChange,
  total,
  confirm,
}) {
  function cancel(e) {
    console.log(e);
  }
  const user = useContext(UserContext);
  return (
    <div>
      <Table
        loading={loading}
        size="small"
        pagination={{ pageSize: 10, total }}
        onChange={handleTableChange}
        style={{ width: "100%" }}
        dataSource={motoristas}
        rowKey="id"
      >
        <Column title="Código" dataIndex="id" key="id" />

        <Column title="Motorista" dataIndex="nome" key="nome" />
        <Column title="CNH" dataIndex="cnh" key="cnh" />
        <Column title="Categoria CNH" dataIndex="categoria_cnh" key="categoria_cnh" />
        <Column
          title="Ação"
          key="action"
          render={(text, record) => (
            <Space size="middle">
              <a onClick={() => history.push(`/motoristas/${record.id}`)}>
                Visualizar
              </a>

              {user?.type === "ADM" && (
                <Popconfirm
                  title="Deseja deletar o motorista?"
                  onConfirm={() => confirm(record)}
                  onCancel={cancel}
                  okText="Sim"
                  cancelText="Não"
                >
                  <a>Deletar</a>
                </Popconfirm>
              )}
            </Space>
          )}
        />
      </Table>
    </div>
  );
}
